import gql from 'graphql-tag';

import { PlusOneGuest } from 'types/plus-one.types';

export interface AdminSetSessionPlusOneGuestsInput {
  gid: string;
  sessionId: number;
  plusOneIds: number[];
  sendNotifications?: boolean;
}

export interface AdminSetSessionPlusOneGuestsVariables {
  input: AdminSetSessionPlusOneGuestsInput;
}

export interface AdminSetSessionPlusOneGuestsResponse {
  adminSetSessionPlusOneGuests: {
    ok: boolean;
    guest: {
      gid: string;
      eventId: number;
      plusOnes: PlusOneGuest[];
    };
  };
}

export const ADMIN_SET_SESSION_PLUS_ONE_GUESTS_MUTATION = gql`
  mutation adminSetSessionPlusOneGuests($input: AdminSetSessionPlusOneGuestsInput!) {
    adminSetSessionPlusOneGuests(input: $input) {
      ok
      guest {
        gid
        eventId
        plusOnes {
          ... on PlusOneGuest {
            __typename
            plusOneId
            eventId
            firstName
            lastName
            email
            questionnaireResponses
            status
          }
        }
      }
    }
  }
`;
